import styled, { css } from 'styled-components';

import { ScGamesGridItem } from '@/components/GameItem/styled';
import { ScSectionTitle } from '@/components/SectionTitle/styled';
import { device } from '@/styles/helpers';

export const ScSearch = styled.div`
  transition: all 0s ease 0s;

  & > .button-search {
    width: 192px;
    height: 40px;
    border-radius: 28px;
    background-color: ${({ theme }) => theme.grayLightColor};
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.blackLightColor};

    svg {
      vertical-align: middle;
      display: inline-block;
    }

    & > .value {
      flex: auto;
      padding: 0 0px 0 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
    }

    & > .icon {
      margin-right: 4px;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @media (hover: hover) {
      &:hover {
        & > .value {
          color: ${({ theme }) => theme.whiteColor};
        }

        svg {
          path {
            fill: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }

    @media (${device.mobileS}) {
      width: auto;
      border-radius: 50%;
      max-width: 100%;

      & > .icon {
        margin: 0;
      }

      & > .value {
        display: none;
      }
    }
  }
`;

export const ScSearchModal = styled.div`
  width: 100%;
  margin: 0 auto;

  .loading-ellipsis {
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  ${ScGamesGridItem} {
    & .badges {
      background: ${({ theme }) => theme.whiteColor};

      @media (${device.mobileS}) {
        background: ${({ theme }) => theme.blackColor};
      }
    }

    & .image {
      transform: translateZ(0);
    }
  }
`;

export const ScSearchForm = styled.div<{ isFormFocused?: boolean }>`
  position: relative;
  margin-bottom: 24px;

  form {
    position: relative;
    z-index: 10;

    input {
      background: ${({ theme }) => theme.gray1Color};
      border-width: 2px;
      border-style: solid;
      border-color: transparent;
      color: ${({ theme }) => theme.blackColor};

      &::placeholder {
        color: ${({ theme }) => theme.blackLightColor};
      }
    }

    & > button {
      width: 24px;
    }

    .search-icon {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;

      svg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  ${({ isFormFocused }) =>
    isFormFocused &&
    css`
      form input:focus {
        border-color: ${({ theme }) => theme.grayMegaLightColor};
      }
    `}

  @media (${device.mobileS}) {
    form input {
      background: ${({ theme }) => theme.grayDarkColor};
      color: ${({ theme }) => theme.whiteColor};

      &::placeholder {
        color: ${({ theme }) => theme.blackLightColor} !important;
      }

      &:focus {
        border-color: ${({ theme }) => theme.grayColor};
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;

export const ScResult = styled.div`
  margin-top: 24px;

  & > p {
    margin-bottom: 15px;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  .badges > div {
    background-color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobileS}) {
      background-color: ${({ theme }) => theme.blackColor};
    }
  }

  & > ${ScSectionTitle} {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.02em;
    margin-bottom: 12px;

    @media (${device.mobileS}) {
      font-size: 20px;
      line-height: 26px;
      margin-bottom: 16px;
    }
  }
`;
